import { useAuthContext } from 'contexts/AuthContext';
import { useInfiniteQuery } from 'react-query';
import { AuditType, IResAudit } from 'types/api';
import { get } from './api';
import { API_ROUTES } from './apiRoutes';
import QueryKeys from './queryKeys';

const getAuditEvents = async (
	type: AuditType,
	text: string,
	page: number
): Promise<IResAudit> => {
	const res = await get<IResAudit>(API_ROUTES.audit(type, page, text));
	return res.data;
};

// Pages are 0-based and fixed in size by the server, which says whether another one exists.
export const useAuditEvents = (type: AuditType, text: string) => {
	const { authRes } = useAuthContext();

	return useInfiniteQuery({
		queryKey: [QueryKeys.audit, type, text],
		queryFn: ({ pageParam = 0 }) => getAuditEvents(type, text, pageParam),
		getNextPageParam: (lastPage, allPages) =>
			lastPage.hasMore ? allPages.length : undefined,
		// A focus refetch would re-request every loaded page.
		refetchOnWindowFocus: false,
		enabled: authRes.verified
	});
};
